import { Fragment } from "react";

import { formatDate } from "@/lib/dayjs/format-date";

import { PrintItemTBodyLayout, PrintItemTHeadLayout, PrintSectionLayout } from "../../layout";

import type { QueryData } from "../../../model";

type Props = {
	items: QueryData["aliveItemsPerDate"];
};

export const EachDaysOfPrintComposition = ({ items }: Props) => {
	return (
		<PrintSectionLayout titleChildren={<p className="text-sm font-bold">日ごとの部屋</p>}>
			<div>
				<PrintItemTHeadLayout />

				{items.map((item, _idx) => {
					const { date, rooms, options } = item;
					const dateText = formatDate(date, "MM月DD日(ddd)");

					return (
						<Fragment key={_idx}>
							{/* 部屋 */}
							{rooms.map((room, __idx) => {
								const roomKey = `room-${_idx}-${__idx}`;
								const { name, hostInsertedPrice, discountedPrice, price } = room;
								/**
								 * 順に優先度が高い
								 */
								const actualPrice = hostInsertedPrice ?? discountedPrice ?? price;

								return (
									<PrintItemTBodyLayout
										key={roomKey}
										free={dateText}
										name={name}
										price={price}
										actualPrice={actualPrice}
									/>
								);
							})}

							{/* オプション */}
							{options.map((option, __idx) => {
								const optionKey = `option-${_idx}-${__idx}`;
								const { name, hostInsertedPrice, discountedPrice, price } = option;
								/**
								 * 順に優先度が高い
								 */
								const actualPrice = hostInsertedPrice ?? discountedPrice ?? price;

								return (
									<PrintItemTBodyLayout
										key={optionKey}
										free={dateText}
										name={name}
										price={price}
										actualPrice={actualPrice}
									/>
								);
							})}
						</Fragment>
					);
				})}
			</div>
		</PrintSectionLayout>
	);
};
